import { defineMessages } from 'react-intl'

const scope = `procurify.expense.presenter.DeleteExpenseReportPresenter`

export default defineMessages({
  confirmTitle: {
    id: `${scope}.confirmTitle`,
    defaultMessage: 'Removal confirmation',
  },
  confirmMessage: {
    id: `${scope}.confirmMessage`,
    defaultMessage: 'Are you sure you want to remove this expense report?',
  },
  confirmButton: {
    id: `${scope}.confirmButton`,
    defaultMessage: 'Remove expense report',
  },
  deleteSuccess: {
    id: `${scope}.deleteSuccess`,
    defaultMessage: 'Expense request #{expenseId} has been removed',
  },
  deleteError: {
    id: `${scope}.deleteError`,
    defaultMessage:
      'Expense request #{expenseId} could not be removed. {error}',
  },
})
